import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private tabFunctionCallSource = new Subject<void>();
  tabFunctionCalled$ = this.tabFunctionCallSource.asObservable();

  callTabFunction() {
    this.tabFunctionCallSource.next();
  }
}
